import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import router from './router';
import { RouterProvider } from 'react-router-dom';
import VConsole from 'vconsole';
import { SafeAreaManager } from './utils/safeArea';
import App from './App';
import posthog from 'posthog-js';
import BoosterNativeBridge from './jsBridge'

import './index.css';
import { safeArea } from './utils/safeArea';
import { initLocale, initLocaleListener } from './i18n';

// PostHog 分析初始化（API Key 从环境变量读取，同 api.js 的 REACT_APP_ 约定）
posthog.init(
  process.env.REACT_APP_POSTHOG_KEY || 'phc_CRUVA69BXwoB8YMyrAC969Gdqf8obosAb7q9ThmefnRB',
  {
    api_host: process.env.REACT_APP_POSTHOG_HOST || 'https://us.posthog.com',
    capture_pageview: true,   // 自动捕获页面浏览（PV）
    capture_pageleave: true,  // 自动捕获离开（停留时间）
    autocapture: false,       // 如需点击热力图可开 true
  }
);
window.posthog = posthog; // 挂到全局，方便控制台调试（npm 包默认不会自动挂 window.posthog）

SafeAreaManager.getInstance().calculate();

// // 首次加载：向 Native 拉取当前语言初始化国际化（异步，不阻塞渲染）
initLocale();
// // 接收 Native 主动推送的语言变化：App 切语言后直接跟随
 initLocaleListener();

// VConsole 悬浮调试面板（需要时再打开）
// const script = document.createElement('script');
// script.src = 'https://unpkg.com/vconsole@latest/dist/vconsole.min.js';
// script.onload = () => {
//   new window.VConsole();
// };
// document.body.appendChild(script);
// 引入安全区域初始化逻辑（你写的 safeArea.js 中的类或函数）



// 🔥 关键：在React渲染之前就计算安全区域
console.log('🚀 在React渲染前计算安全区域');

// 方法A：直接读取env()并设置
if (CSS.supports('padding: env(safe-area-inset-left)')) {
  const temp = document.createElement('div');
  temp.style.cssText = `
    position: fixed;
    padding-left: env(safe-area-inset-left);
    visibility: hidden;
  `;
  document.body.appendChild(temp);
  const style = window.getComputedStyle(temp);
  const leftValue = parseFloat(style.paddingLeft) || 0;
  document.body.removeChild(temp);

  // 立即设置到根元素
  if (leftValue > 0) {
    document.documentElement.style.setProperty('--safe-area-left', `${leftValue}px`);
    document.documentElement.style.setProperty('--safe-area-right', '0px');
    document.documentElement.style.setProperty('--safe-area-top', '0px');
    document.documentElement.style.setProperty('--safe-area-bottom', '0px');
    console.log(`🔥 立即设置安全区域: ${leftValue}px`);
  }
}

// 方法B：如果env()不行，用设备检测
const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
const isLandscape = window.innerWidth > window.innerHeight;
if (isIOS && isLandscape) {
  document.documentElement.style.setProperty('--safe-area-left', '44px');
  document.documentElement.style.setProperty('--safe-area-right', '0px');
  console.log('🔥 iOS横屏预设44px');
}

const root = ReactDOM.createRoot(document.getElementById('root'));

const runSafeArea = () => {
  const values = safeArea.calculate();
  console.log('safeArea.calculate() values=', values);

  // 关键：验证是否真的写进了 CSS 变量
  const style = getComputedStyle(document.documentElement);
  console.log('root css vars:',
    style.getPropertyValue('--safe-area-left'),
    style.getPropertyValue('--safe-area-right'),
    style.getPropertyValue('--safe-area-top'),
    style.getPropertyValue('--safe-area-bottom')
  );
};

runSafeArea(); // 尽量在渲染前/尽可能早

// root.render(<App />);


root.render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
